/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsCloneMutationRequest, ProjectsCloneMutationResponse, ProjectsClonePathParams } from "../models/ProjectsClone";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { projectsClone } from "../axios/projectsClone";
import { useMutation } from "@tanstack/react-query";

export const projectsCloneMutationKey = () => ["video-editor-api", { url: '/projects/:id/clone' }] as const

export type ProjectsCloneMutationKey = ReturnType<typeof projectsCloneMutationKey>

/**
 * @summary Clone a project (requires new name)
 * {@link /projects/:id/clone}
 */
export function useProjectsClone<TContext>(options: 
{
  mutation?: UseMutationOptions<ProjectsCloneMutationResponse, ResponseErrorConfig<Error>, {id: ProjectsClonePathParams["id"], data: ProjectsCloneMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ProjectsCloneMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? projectsCloneMutationKey()

  return useMutation<ProjectsCloneMutationResponse, ResponseErrorConfig<Error>, {id: ProjectsClonePathParams["id"], data: ProjectsCloneMutationRequest}, TContext>({
    mutationFn: async({ id, data }) => {
      return projectsClone(id, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}